
import { useStore } from 'react-admin';

export const useValueRange = (): [number, number] => {
  const [valueRange] = useStore<number[]>('map.valueRange', [0, 0]);
  return [valueRange[0], valueRange[1]];
}
